'use client'

import { Text } from '@mantine/core'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { tokenizedStocksLocales } from '@/i18n/locales'
import { useIsOgApp } from '@/utils/og'

export default function CoinsTableTitleClient() {
  const coinTableT = useTranslations('coinTable')
  const { locale } = useParams<{ locale: string }>()
  const isOgApp = useIsOgApp()

  if (isOgApp) return null

  const isTokenizedStocks = (tokenizedStocksLocales as string[]).includes(locale)

  return (
    <Text component="h2" variant="heading1" c="#fff">
      {isTokenizedStocks ? coinTableT('tokenizedStocksTitle') : coinTableT('title')}
    </Text>
  )
}
